<template>
    <div class="temper">
        <div class="title">
            <div class="title-text">设备温度监测</div>
        </div>
        <div class="temper-box">
            <div class="temper-list">
                <div class="temper-top top">
                    <div class="">设备编号</div>
                    <div class="">设备名称</div>
                    <div class="">温度</div>

                </div>
                <div class="temper-bottom">
                    <div class="temper-bottom-info">
                        <span>AK0213</span>
                        <span>气罐</span>
                        <span>75.7℃</span>
                        <div class="temper-bottom-info-bg"></div>
                    </div>
                </div>
            </div>
            <div class="temper-list">
                <div class="temper-top">
                    <div class="">AK0214</div>
                    <div class="">气罐</div>
                    <div class="">75.8℃</div>

                </div>
                <div class="temper-bottom">
                    <div class="temper-bottom-info">
                        <span>AK0215</span>
                        <span>气罐</span>
                        <span>75.9℃</span>
                        <div class="temper-bottom-info-bg"></div>
                    </div>
                </div>
            </div>
            <div class="temper-list">
                <div class="temper-top">
                    <div class="">AK0216</div>
                    <div class="">气罐</div>
                    <div class="">75.10℃</div>

                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "temperature"
    }
</script>

<style scoped lang="less">

    .temper-box {
        font-family: sy;
        width: 90%;

        font-size: 12px;
        color: white;
        .temper-list {
            margin-top: 8px;
            .temper-top {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 3px 10px;
                box-sizing: border-box;
                background: url('./../../assets/img/box.png');
                background-size: 100% 100%;
                &.top{
                    background: url('./../../assets/img/topbox.png');
                }
            }

            .temper-bottom {
                .temper-bottom-info {
                    position: relative;

                    padding: 3px 10px;
                    padding-top: 10px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    .temper-bottom-info-bg{
                        position: absolute;
                        bottom: 0;
                        width: 100%;
                        height: 2px;
                        background: url("./../../assets/img/list.png") no-repeat;

                    }
                }
            }
        }
    }
</style>